import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { PiCompassBold } from "react-icons/pi";

const NotFoundPage: React.FC = () => {
  return (
    <Box
      className="bg-hex-gray-100"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 420,
          textAlign: "center",
          px: 5,
          py: 6,
          background: "transparent"
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            mx: "auto",
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
              "linear-gradient(135deg, rgba(39, 35, 102, 0.08), rgba(145, 88, 206, 0.18))",
          }}
        >
          <PiCompassBold size={28} color="#9158CE" />
        </Box>

        <Typography
          variant="h5"
          sx={{ fontWeight: 700, color: "text.primary" }}
        >
          Page Not Found
        </Typography>
        <Typography sx={{ mt: 1.5, color: "text.secondary", lineHeight: 1.6 }}>
          The page you're looking for doesn't exist or may have been moved.
        </Typography>
      </Paper>
    </Box>
  );
};

export default NotFoundPage;
